import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  Grid,
  InputAdornment,
  IconButton,
  Alert,
} from "@mui/material";
import { Visibility, VisibilityOff, Person, Lock } from "@mui/icons-material";

import API_URL from "../config/api";

export default function Login() {
  const [form, setForm] = useState({ login: "", senha: "" });
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const resp = await axios.post(`${API_URL}/auth/login`, form, {
        headers: { "Content-Type": "application/json" }
      });

      localStorage.setItem("token", resp.data.token);

      if (resp.data.refreshToken) {
        localStorage.setItem("refreshToken", resp.data.refreshToken);
      }

      localStorage.setItem(
        "usuario",
        JSON.stringify({ nome: resp.data.usuario })
      );

      localStorage.setItem("codigoVendedor", resp.data.codigoVendedor);

      localStorage.setItem(
        "administrador",
        resp.data.administrador ? "S" : "N"
      );

      window.location.href = "/dashboard";

    } catch (err) {
      console.log("ERRO AO FAZER LOGIN:", err);
      setError("Usuário ou senha inválidos");
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        background: "linear-gradient(135deg, #0080AA 0%, #00A8E8 100%)",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        },
      }}
    >
      <Container maxWidth="lg">
        <Grid
          container
          sx={{
            minHeight: "100vh",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Grid item xs={12} md={10} lg={8}>
            <Paper
              elevation={24}
              sx={{
                borderRadius: 4,
                overflow: "hidden",
                background: "white",
              }}
            >
              <Grid container>
                {/* Lado Esquerdo - Imagem e Branding */}
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    background: "linear-gradient(135deg, #00619E 0%, #0080AA 100%)",
                    p: 6,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "white",
                    position: "relative",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.1' fill-rule='evenodd'/%3E%3C/svg%3E")`,
                      opacity: 0.3,
                    },
                  }}
                >
                  <Box sx={{ position: "relative", zIndex: 1, textAlign: "center" }}>
                    {/* Logo */}
                    <Box
                      component="img"
                      src="/Logo1.jpg"
                      alt="Farinha & Cia"
                      sx={{
                        maxWidth: "200px",
                        height: "auto",
                        mb: 4,
                        borderRadius: 2,
                        boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
                      }}
                    />

                    <Typography variant="h4" fontWeight="bold" gutterBottom>
                      Bem-vindo!
                    </Typography>

                    <Typography variant="h6" sx={{ mb: 4, opacity: 0.95 }}>
                      Farinha & Cia
                    </Typography>

                    <Box sx={{ mb: 3 }}>
                      <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8 }}>
                        Distribuidora de Produtos
                      </Typography>
                                          </Box>

                    <Box
                      sx={{
                        mt: 5,
                        pt: 3,
                        borderTop: "1px solid rgba(255,255,255,0.2)",
                      }}
                    >
                      <Typography variant="body2" sx={{ opacity: 0.7 }}>
                        Sistema de Gestão ERP
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                {/* Lado Direito - Formulário de Login */}
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    p: 6,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h4"
                      fontWeight="bold"
                      gutterBottom
                      sx={{ color: "#0080AA", mb: 1 }}
                    >
                      Entrar
                    </Typography>

                    <Typography
                      variant="body1"
                      color="text.secondary"
                      sx={{ mb: 4 }}
                    >
                      Acesse sua conta para continuar
                    </Typography>

                    {error && (
                      <Alert severity="error" sx={{ mb: 3 }}>
                        {error}
                      </Alert>
                    )}

                    <form onSubmit={handleSubmit}>
                      <TextField
                        label="Usuário"
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        value={form.login}
                        onChange={(e) => setForm({ ...form, login: e.target.value })}
                        required
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Person sx={{ color: "#0080AA" }} />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          mb: 2,
                          "& .MuiOutlinedInput-root": {
                            "&:hover fieldset": {
                              borderColor: "#0080AA",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#0080AA",
                            },
                          },
                          "& .MuiInputLabel-root.Mui-focused": {
                            color: "#0080AA",
                          },
                        }}
                      />

                      <TextField
                        label="Senha"
                        type={showPassword ? "text" : "password"}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        value={form.senha}
                        onChange={(e) => setForm({ ...form, senha: e.target.value })}
                        required
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Lock sx={{ color: "#0080AA" }} />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => setShowPassword(!showPassword)}
                                edge="end"
                              >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          mb: 3,
                          "& .MuiOutlinedInput-root": {
                            "&:hover fieldset": {
                              borderColor: "#0080AA",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#0080AA",
                            },
                          },
                          "& .MuiInputLabel-root.Mui-focused": {
                            color: "#0080AA",
                          },
                        }}
                      />

                      <Button
                        variant="contained"
                        type="submit"
                        fullWidth
                        size="large"
                        disabled={loading}
                        sx={{
                          mt: 2,
                          py: 1.5,
                          background: "linear-gradient(135deg, #0080AA 0%, #00A8E8 100%)",
                          fontSize: "1rem",
                          fontWeight: "bold",
                          textTransform: "none",
                          boxShadow: "0 4px 14px rgba(0, 128, 170, 0.4)",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            background: "linear-gradient(135deg, #00619E 0%, #0080AA 100%)",
                            boxShadow: "0 6px 20px rgba(0, 128, 170, 0.6)",
                            transform: "translateY(-2px)",
                          },
                          "&:disabled": {
                            background: "#ccc",
                          },
                        }}
                      >
                        {loading ? "Entrando..." : "Entrar"}
                      </Button>
                    </form>

                    <Box sx={{ mt: 4, textAlign: "center" }}>
                      <Typography variant="caption" color="text.secondary">
                        © 2026 Farinha & Cia. Todos os direitos reservados.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
